import { useEffect, useState } from 'react'
import { Button, Row, Select } from 'antd'
import { BranchesOutlined, DatabaseOutlined } from '@ant-design/icons'
import { downloadFile } from 'Services/WeaverUtils'
import GeneralTemplate from './general'

GenerateFile = GeneralTemplate({
  InputHandler: ({ startPlugin }) ->

    [loading, setLoading] = useState(true)
    [branch, setBranch] = useState(undefined)
    [branches, setBranches] = useState(undefined)

    useEffect( ->
      setBranches(undefined)
      setLoading(true)
      ( ->
        b = await Weaver.Branch.list()
        setBranches(b)
        setBranch(b[0].id())
        setLoading(false)
      )()
      undefined
    , [])
    <div style={{ textAlign: 'center' }}>
      <div style={{ margin: 15, textAlign: 'left' }}>
        Branch to use:
        <Select
          disabled={!branches}
          loading={loading}
          value={branch}
          placeholder="Choose a branch"
          options={branches?.map((b) -> { value: b.id(), label: b.name() })}
          onSelect={setBranch}
          style={{ width: '100%' }}
        />
      </div>

      <Button
        onClick={-> startPlugin({ branch })}
        icon={<DatabaseOutlined />}
        type="primary"
        size="large"
        shape="round"
        ghost
      >
        Generate turtle file
      </Button>
    </div>
  ResponseHandler: ({ response }) ->
    <Button
      shape="round"
      type="primary"
      onClick={ -> downloadFile(response.fileId, 'export.ttl', true)}
    >
      Download file
    </Button>
})

export default GenerateFile
